import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";
import { isMarketingSitePath } from "../pages/marketing-site/marketingSiteRoutes";
import { getLocale } from "./localeRegistry";
import { useInterfaceLanguage } from "./interfaceLanguageRuntime";
import { LocaleFontStyles } from "../fonts/localization-fonts/LocaleFontStyles";

/** The app owns its document locale; public pages keep their URL-owned Helmet attributes. */
export function AppLocaleSync() {
  const { pathname } = useLocation();
  const { effectiveLocale } = useInterfaceLanguage();
  const isMarketingPage = isMarketingSitePath(pathname);
  const { direction } = getLocale(effectiveLocale);
  // Share Helmet's ownership with public pages. A separate DOM effect can lose
  // to a public Helmet unmount restoring its attributes after this route renders.
  return isMarketingPage ? null : <>
    <Helmet defer={false} htmlAttributes={{ lang: effectiveLocale, dir: direction }} />
    <LocaleFontStyles locale={effectiveLocale} />
  </>;
}
